"use client";
import { createContext, useContext, useLayoutEffect } from "react";
import { usePathname } from "next/navigation";
import type { DocsHeading } from "./contents-navigation";

export type PageContents = { path: string; headings: DocsHeading[] } | null;
export const DocsContentsContext = createContext<(value: PageContents) => void>(
  () => {},
);
export function DocsPageContents({ headings }: { headings: DocsHeading[] }) {
  const setContents = useContext(DocsContentsContext);
  const pathname = usePathname();
  useLayoutEffect(() => {
    setContents({ path: pathname, headings });
    return () => setContents(null);
  }, [pathname, headings, setContents]);
  return null;
}
